<template>
  <auth-layout pageClass="login-page">
    <div class="row d-flex justify-content-center align-items-center">
      <div class="col-lg-4 col-md-6 col-sm-8" >
          <!--You can specify transitions on initial render. The `card-hidden` class will be present initially and then it will be removed-->
          <fade-render-transition>
            <card >
              <div slot="header">
                <h3 class="card-title text-center">Login</h3>
              </div>
              <div>
                <fg-input label="User Name"
                          placeholder="Enter User Name"
                          type="text"
                          v-model="model.userName">

                </fg-input>
                <fg-input label="Passsword"
                          type="password"
                          placeholder="Password"
                          v-model="model.password"
                          v-on:keyup.enter="doLogin">
                </fg-input>
              </div>
              <div class="text-center">
                <button type="submit" class="btn btn-fill btn-info btn-round btn-wd " v-on:click='doLogin()'>Login</button>
                <br>
              </div>
            </card>
          </fade-render-transition>
      </div>
    </div>
  </auth-layout>
</template>
<script>
/* eslint-disable */ 
  import { FadeRenderTransition } from 'src/components/index'
  import AuthLayout from './AuthLayout.vue'
  import lib from '../../../lib.js'
  export default {
    components: {
      FadeRenderTransition,
      AuthLayout
    },
    data () {
      return {
        model: {
          userName: '',
          password: ''
        },
        showAlert:false
      }
    },
    methods: {
      async doLogin(){
        var data = await lib.userLogin(this.model.userName, this.model.password)
        if (data.status == 0){
          var result = data.result
          var user = result.user
          user.token = result.token
          this.$store.commit('set_user', JSON.stringify(user))
          this.$router.push('/admin/items')
        }else if (data.status == 103){
          this.$swal('帳號已被停用', '', 'error')
        }else{
          this.$swal('帳號密碼錯誤', '', 'error')
        }
      },
      toggleNavbar () {
        document.body.classList.toggle('nav-open')
      },
      closeMenu () {
        document.body.classList.remove('nav-open')
        document.body.classList.remove('off-canvas-sidebar')
      }
    },
    beforeDestroy () {
      this.closeMenu()
    }
  }
</script>
<style>
  .navbar-nav .nav-item p{
    line-height: inherit;
    margin-left: 5px;
  }
</style>
